module.exports = __webpack_public_path__ + "static/david-shaw-headshot-15d5e13cef1e4c75b5cfd0ed9fb0d759.png";